import i18n from 'src/i18n';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 120,
      sortable: true,
    },
    {
      prop: 'code',
      label: i18n.t('common_words.code'),
      minWidth: 70,
      sortable: true,
      align: 'center',
      formatter: (row) => {
        return row.code ? row.code : 'No asignado'
      },
    },
    {
      prop: 'size',
      label: i18n.t('common_words.size'),
      minWidth: 70,
      sortable: true,
      align: 'center',
      formatter: (row) => {
        return row.size ? row.size : 'No asignado'
      },
    },
    {
      prop: 'description',
      label: i18n.t('common_words.description'),
      minWidth: 160,
      sortable: true,
    },
  ];
  return { tableColumns };
};
export default configTable;
